// @flow
import { put, delay } from 'redux-saga/effects';
import { selectUserId } from 'flowhawk-core';
import { select as typedSelect } from 'typed-redux-saga';

import { apiPut } from './ApiSaga';
import api from '../Services/Api';
import createUuid from '../Utils/createUuid';
import { setDeviceToken } from '../Redux/ApplicationActions';
import type { StoreDeviceToken } from '../Redux/ApplicationActions';
import type { RootState } from '../Redux';

export default function* storeDeviceToken(action: StoreDeviceToken) {
  const memberId = yield* typedSelect((state: RootState) => selectUserId(state.auth));
  const deviceId = createUuid(memberId);
  yield delay(200);
  yield apiPut(api.txp.saveDeviceToken, undefined, {
    fcm_registration_token: action.deviceToken,
    device_os: 'web',
    device_id: deviceId,
  });

  yield put(setDeviceToken(action.deviceToken));
}
